import { Routes, Route, Navigate, BrowserRouter } from 'react-router-dom';
import { useAuth } from '../provider/authProvider';
import { ProtectedRoute } from './protectedRoutes';
import { AdminRoute } from './admin_routes';
import LoginPage from '../pages/Login';
import DashboardPage from '../pages/DashboardPage';
import RegisterPage from '../pages/Register';
import ManualOrderClose from '../pages/ManualOrderClose';
import LandingPage from '../pages/LandingPage';
import AdminMainPage from '../pages/Admin/admin_main_page';
import TemplateLibraryPage from '../Components/Admin/TemplateLibraryPage';
import AssignStrategyPage from '../pages/Admin/AssignStrategyPage';
import AlgoAnalyticsDashboard from '../pages/AlgoAnalyticsDashboard';
import AICoachPage from '../pages/AICoachPage';

// Q AI Standalone Pages
import QAILandingPage from '../pages/QAI/QAILandingPage';
import QAISignupPage from '../pages/QAI/QAISignupPage';
import QAILoginPage from '../pages/QAI/QAILoginPage';
import QAICoachPage from '../pages/QAI/QAICoachPage';

const AppRoutes = ()=>{
    const {token} = useAuth();
    
    // Debug logging
    
    return (
        <BrowserRouter>
            <Routes>
                {/* Q AI Standalone Routes (always accessible) */}
                <Route path="/q-ai" element={<QAILandingPage />} />
                <Route path="/q-ai/signup" element={<QAISignupPage />} />
                <Route path="/q-ai/login" element={<QAILoginPage />} />
                <Route path="/q-ai/coach" element={<QAICoachPage />} />

                {!token ? (
                    // Public routes for unauthenticated users
                    <>
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/register" element={<RegisterPage />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </>
                ) : (
                    // Protected routes for authenticated users
                    <>
                        <Route path="/" element={<Navigate to="/dashboard" replace />} />
                        <Route path="/dashboard" element={
                            <ProtectedRoute>
                                <DashboardPage />
                            </ProtectedRoute>
                        } />
                        <Route path="/logout" element={
                            <ProtectedRoute>
                                <></>
                            </ProtectedRoute>
                        } />
                        <Route path="/adminPanel" element={
                            <AdminRoute>
                                <AdminMainPage />
                            </AdminRoute>
                        } />
                        <Route path="/adminPanel/templates" element={
                            <AdminRoute>
                                <TemplateLibraryPage />
                            </AdminRoute>
                        } />
                        <Route path="/adminPanel/assign-strategy" element={
                            <AdminRoute>
                                <AssignStrategyPage />
                            </AdminRoute>
                        } />
                        <Route path="/manual-close" element={
                            <ProtectedRoute>
                                <ManualOrderClose />
                            </ProtectedRoute>
                        } />
                        <Route path="/algo-analytics" element={
                            <ProtectedRoute>
                                <AlgoAnalyticsDashboard />
                            </ProtectedRoute>
                        } />
                        <Route path="/ai-coach" element={
                            <ProtectedRoute>
                                <AICoachPage />
                            </ProtectedRoute>
                        } />
                        <Route path="*" element={<Navigate to="/dashboard" replace />} />
                    </>
                )}
            </Routes>
        </BrowserRouter>
    );
}

export default AppRoutes;